import React, { Component } from "react";

import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";
import axios from "axios";
import TextareaField from "./form/TextareaField";
import TextField from "./form/TextField";
//import Tooltip from "@material-ui/core/Tooltip";
import Loader from "./Loader";
import Modal from "./Modal";
import Persontags from "./Persontags";
import Tooltip from "@material-ui/core/Tooltip";

import db from "../../api/db";

class List extends Component {
  static propTypes = {
    Date: PropTypes.object.isRequired,
    Persons: PropTypes.array,
    Type: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      persons: [],
      working: true,
      workingstring: "Ser etter lister ...",
      submitmessage: "",
      submitmail: "dokumentsenter@canon.no",
      submitsubject: "",
      showModal: false,
      showFlengModal: false,
      sendinglist: false,
      editmode: this.props.Editmode ? this.props.Editmode : false,
      loadprogress: 0,
      flengText: "",
      copied: false
    };
  }

  componentDidMount() {
    this.getList(this.props.Date, this.props.Type);
  }

  componentWillReceiveProps(props) {
    if (
      JSON.stringify(this.props.Date) !== JSON.stringify(props.Date) ||
      JSON.stringify(this.props.Type) !== JSON.stringify(props.Type) ||
      JSON.stringify(this.props.Client) !== JSON.stringify(props.Client) ||
      this.state.list.length === 0
    ) {
      this.getList(props.Date, props.Type, props.Client);
    }
  }

  handleShowMessageClick = () => this.handleShowMessage();
  handleCloseModal = () => this.setState({ showModal: false });
  handleCloseFlengModal = () => this.setState({ showFlengModal: false });
  handleSubmitModal = () => this.submitList();
  handleSubmitFleng = () => this.submitFlengList();
  handleSubmitModalExport = () => this.submitList(true);
  handleSubmitChange = e => this.setState({ submitmessage: e.target.value });
  handleEmailChange = e => this.setState({ submitmail: e.target.value });
  handleFlengChange = e => this.setState({ flengText: e.target.value });

  handleSetEdit = () => this.setEdit();

  handleShowMessage() {
    if (this.props.Type === "mention") {
      this.setState({ showModal: true });
    } else if (this.props.Type === "fleng") {
      this.setState({
        showFlengModal: true,
        flengText: this.createFlengText()
      });
    } else {
      console.log("Unknown list type");
    }
  }

  submitFlengList() {
    navigator.clipboard.writeText(this.state.flengText);

    this.setState({ copied: true });

    let list = this.state.list;
    list.submitted = moment().format();

    db.patch("list", list).then(response => {
      this.setState({
        list: response.data
      });
    });
  }

  submitList(simpleList = false) {
    const list = this.state.list;

    this.setState({
      sendinglist: true,
      showModal: false
    });

    var url = "/api/operations/sendmentionmail";

    if (simpleList) {
      url = "/api/operations/sendsinglelist";
    }

    axios({
      method: "post",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json"
      },
      url: url,
      data: {
        list: list.id,
        mail: !simpleList ? this.state.submitmail : "personalia@ntb.no",
        message: this.state.submitmessage,
        subject: `Omtale ${moment(list.date).format("DD.MM.YYYY")}`,
        year: moment(this.state.list.date).format("YYYY")
      }
    })
      .then(response => {
        this.setState({
          sendinglist: false,
          submitmessage: ""
        });
        this.getList();
      })
      .catch(err => {
        console.log(err);
        this.setState({
          sendinglist: false,
          submitmessage: ""
        });
      });
  }

  getList(
    date = this.props.Date,
    type = this.props.Type,
    client = this.props.Client
  ) {
    db.query("list", {
      date: this.formatDate(date),
      type: type,
      db: true
    }).then(response => {
      let list = {};
      if (response.data.length) {
        list = response.data.shift();
      }
      this.setState({
        list: list,
        working: true,
        editmode: false
      });

      this.getPersonInfo(list.persons);
      this.props.setListPersons(list.persons);
    });
  }

  setEdit() {
    const listName = `${this.humanType()} ${moment(this.state.list.date).format(
      "DD.MM. YYYY"
    )}`;

    this.props.Setedit(this.state.persons, listName);

    this.setState({
      editmode: true,
      persons: []
    });
  }

  abortEdit() {
    this.setState({
      editmode: false
    });

    this.getList();
  }

  setProgress(n) {
    this.setState({
      loadprogress: n
    });
  }

  getPersonInfo(persons = []) {
    this.setState({
      working: true,
      workingstring: "Ser etter lister ..."
    });

    if (persons.length) {
      this.setState({
        workingstring: "Henter informasjon om person(er).."
      });

      db.getMultiple("person", persons).then(res => {
        this.setState({
          persons: res.data.hits,
          working: false,
          loadprogress: 0
        });
      });
    } else {
      this.setState({
        persons: [],
        working: false
      });
    }
  }

  formatDate(date, unix = false) {
    if (unix) {
      return moment(date).unix();
    }
    return moment(date).format("YYYY-MM-DD");
  }

  receivePayload(payload, boot = false) {
    this.setState(
      {
        working: true,
        workingstring: "Legger til person(er) ..."
      },
      () => {
        this.props.Status(true);
      }
    );

    let list = this.state.list;

    if (!list.id) {
      // We have no list, we must make one.

      let params = {
        date: this.formatDate(this.props.Date),
        unixdate: this.formatDate(this.props.Date, true),
        type: this.props.Type,
        persons: [...new Set(payload)]
      };

      if (this.props.Client) {
        params["client"] = this.props.Client;
      }
      db.create("list", params)
        .then(response => {
          this.getPersonInfo(response.data.persons);
          this.setState(
            {
              list: response.data,
              editmode: false
            },
            () => {
              this.props.Status(false);
              this.props.setListPersons(params.persons);
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      // List is created, lets patch it.
      let persons;

      if (boot) {
        persons = payload;
      } else {
        persons = list.persons ? list.persons.concat(payload) : payload;
      }

      list.persons = [...new Set(persons)];

      db.patch("list", list).then(response => {
        this.getPersonInfo(response.data.persons);
        this.setState(
          {
            list: response.data,
            editmode: false
          },
          () => {
            this.props.Status(false);
            this.props.setListPersons(list.persons);
          }
        );
      });
    }
  }

  removePerson(id) {
    let list = this.state.list;
    let personlist = [...list.persons];
    const index = personlist.indexOf(String(id));

    if (index !== -1) {
      this.setState({
        working: true,
        workingstring: "Oppdaterer liste ..."
      });

      personlist.splice(index, 1);
      list.persons = personlist;

      db.patch("list", list).then(response => {
        this.getPersonInfo(response.data.persons);
        this.setState(
          {
            list: response.data,
            editmode: false
          },
          () => {
            this.props.Status(false);
            this.props.setListPersons(list.persons);
          }
        );
      });
    }
  }

  personStats(persons = this.state.persons) {
    const count = persons.length;

    let stats = {
      male: 0,
      female: 0,
      old: 0,
      famous: 0,
      mentioned: 0
    };

    let dead = 0;

    if (count) {
      // Get the value from person list
      for (var i = persons.length - 1; i >= 0; i--) {
        if (persons[i].famous) {
          stats.famous += 1;
        }
        if (persons[i].mentioned) {
          stats.mentioned += 1;
        }
        if (persons[i].gender === "Male") {
          stats.male += 1;
        }
        if (persons[i].gender === "Female") {
          stats.female += 1;
        }
        if (
          moment(this.state.list.date).diff(persons[i].birthdate, "years") >= 95
        ) {
          stats.old += 1;
        }
        if (persons[i].code === 5) {
          dead += 1;
        }
      }
      // Transform into percentages
      Object.keys(stats).map(function(key) {
        stats[key] = Math.round((stats[key] / count) * 100);
        if (stats[key] > 100) {
          stats[key] = 100;
        }
        return (stats[key] += "%");
      });
    }

    return (
      <div className="stats">
        {dead ? (
          <div className="search-label alert">Det er {dead} døde i listen</div>
        ) : (
          ""
        )}
        <div className="with-progress">
          <div className="lbl">Menn</div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={stats.male}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="progress-meter" style={{ width: stats.male }}></div>
          </div>
        </div>
        <div className="with-progress">
          <div className="lbl">Kvinner</div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={stats.female}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              className="progress-meter"
              style={{ width: stats.female }}
            ></div>
          </div>
        </div>
        <div className="with-progress">
          <div className="lbl">Kjent</div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={stats.famous}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              className="progress-meter"
              style={{ width: stats.famous }}
            ></div>
          </div>
        </div>
        <div className="with-progress">
          <div className="lbl">Over 95</div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={stats.old}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="progress-meter" style={{ width: stats.old }}></div>
          </div>
        </div>
        <div className="with-progress">
          <div className="lbl">Viktig</div>
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={stats.mentioned}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              className="progress-meter"
              style={{ width: stats.mentioned }}
            ></div>
          </div>
        </div>
      </div>
    );
  }

  createFlengText() {
    this.setState({ copied: false });

    const persons = this.state.persons;
    var string = "";

    persons.sort((a, b) => (a.year < b.year ? 1 : -1));

    for (var i = persons.length - 1; i >= 0; i--) {
      if (i === persons.length - 1) {
        string += "I dag fyller ";
      } else if (i === 0) {
        string += "og ";
      }

      var name = persons[i].fullname;

      if (persons[i].alias) {
        name = persons[i].alias;
      }

      string += `${persons[i].title ? persons[i].title + " " : ""}${name} `;

      if (i > 0) {
        string += `${moment(this.state.list.date).diff(
          persons[i].birthdate,
          "years"
        )} år, `;
      } else if (i === 0) {
        string += `er ${moment(this.state.list.date).diff(
          persons[i].birthdate,
          "years"
        )} år i dag.`;
      }
    }

    const text = `${moment(this.state.list.date).format(
      "DD.MM"
    )} Fødselsdager\n\n${string}`;

    return text;
  }

  loadingBar() {
    const loadprogress = this.state.loadprogress;

    if (!loadprogress || !this.state.list.persons) {
      return;
    }

    const total = this.state.list.persons.length;
    const progress = `${Math.round((loadprogress / total) * 100)}%`;

    return (
      <div className="with-progress">
        <div className="lbl">
          {loadprogress}/{total}
        </div>
        <div
          className="progress"
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <div className="progress-meter" style={{ width: progress }}></div>
        </div>
      </div>
    );
  }

  humanType() {
    const types = {
      mention: "Omtale",
      jubilee: "Jubilantliste",
      fleng: "Fødselsdager"
    };

    return types[this.props.Type];
  }

  confirmActive() {
    if (
      (this.props.Type === "mention" || this.props.Type === "fleng") &&
      !this.state.editmode &&
      this.state.persons.length
    ) {
      return false;
    }

    return true;
  }

  render() {
    let persons;

    const list = this.state.list;
    if (list && this.state.persons) {
      persons = this.state.persons.map((item, i) => (
        <div key={i} data-id={item.id} className={classNames("item")}>
          <Tooltip
            title={
              item.title ? `${item.title} ${item.fullname}` : `${item.fullname}`
            }
          >
            <span className="name">
              {item.firstname} {item.lastname}
            </span>
          </Tooltip>
          <Persontags Tags={item._tags} />
          <span
            className="delete"
            onClick={e => this.removePerson(item.id)}
          ></span>
        </div>
      ));
    }

    return (
      <div
        className={classNames("sidebar", {
          working: this.state.working,
          editmode: this.state.editmode
        })}
      >
        <div className="heading">
          <div className="float-right lbl">
            {this.state.persons.length} totalt
          </div>
          {this.humanType()} {list.client ? list.client.name : ""}
          <br />
          {list.date
            ? moment(list.date).format("DD. MMMM YYYY")
            : moment(this.props.Date).format("DD.MM. YYYY")}
          <div className="lbl">
            {list.submitted
              ? `Sendt: ${moment(list.submitted).format("HH:mm DD.MM.YYYY")}`
              : `Denne listen har ikke blitt sendt.`}
          </div>
        </div>
        <br />
        {this.personStats(this.state.persons)}
        <div className="listbox">{persons}</div>
        <div className="alertbar">
          {this.state.workingstring}
          {this.loadingBar()}
        </div>
        <div className="grid-x bottom-actions">
          <div className="medium-6 cell">
            <button
              onClick={this.handleShowMessageClick}
              className="button expanded"
              disabled={this.confirmActive()}
            >
              Bekreft liste
            </button>
          </div>
          <div className="medium-6 cell">
            <button
              className="button link"
              onClick={this.handleSetEdit}
              disabled={!this.state.persons.length}
            >
              Rediger liste
            </button>
          </div>
        </div>

        {this.state.showModal ? (
          <Modal onClose={this.handleCloseModal} closelabel="Send liste">
            <div>
              <div className="heading">
                Sende «Omtale_{moment(list.date).format("DD.MM.YYYY")}»
              </div>
              <TextField
                className="white-input"
                name="email"
                value={this.state.submitmail}
                label="Epost"
                onChange={this.handleEmailChange}
              />
              <TextareaField
                className="white-input"
                name="submitmessage"
                value={this.state.submitmessage}
                label="Legg ved melding på sendingen"
                onChange={this.handleSubmitChange}
              />
              <p>
                Mailen sendes da til “{this.state.submitmail}” og kopi til
                “personalia@ntb.no”.
              </p>
            </div>
            <button className="button" onClick={this.handleSubmitModal}>
              Send brev
            </button>
            <button className="button" onClick={this.handleSubmitModalExport}>
              Eksporter Liste
            </button>
            <button className="button abort" onClick={this.handleCloseModal}>
              Avbryt
            </button>
          </Modal>
        ) : null}

        {this.state.showFlengModal ? (
          <Modal onClose={this.handleCloseModal} closelabel="Lukk">
            <div>
              <div className="heading">Fødselsdager</div>
              {this.state.copied ? (
                <div className="alertbar">Listen har blitt kopiert!</div>
              ) : (
                ""
              )}
              <TextareaField
                className="white-input"
                name="flengtext"
                value={this.state.flengText}
                label=""
                onChange={this.handleFlengChange}
              />
            </div>
            <button className="button" onClick={this.handleSubmitFleng}>
              Kopier til utklippstavle
            </button>
            <button
              className="button abort"
              onClick={this.handleCloseFlengModal}
            >
              Lukk
            </button>
          </Modal>
        ) : null}

        {this.state.sendinglist ? (
          <Modal>
            <div>
              <Loader />
              <p className="loadmsg">Listen sendes</p>
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default List;
